<template>
  <div id="loginRoot" class="section">
    <img alt="SAGITEAM" src="@/assets/logo2.png">
    <h1 class="title">射手座管理后台(MJPMGR)</h1>
    <div v-if="isLogining">
      <h1>登录中....</h1>
    </div>
    <b-field id="mjpSelector" v-if="!isLogining && isDev" class="container" label="选择MJP">
      <b-select icon="server-network" v-model="selectedAdminMJPIndex" expanded @input="onAdminMJPSelect">
        <option v-for="(o, index) in adminMJPServers"
          :value="index"
          :key="o.name">
          {{o.name}}
        </option>
      </b-select>
    </b-field>
    <b-field v-if="wechatAppLogin" class="buttons" position="is-centered">
        <a :href="wechatAppLogin" class="button is-success">微信登录</a>
        <a :href="workWechatAppLogin" class="button is-primary">企业微信登录</a>
    </b-field>
    <div v-if="!isLogining" class="container">
      <form @submit.prevent="onSubmit" class="container">
        <b-field>
          <b-input v-model.trim="loginUid" placeholder="管理员用户名" icon="account" > </b-input>
        </b-field>
        <b-field >
          <b-input type="password" v-model.trim="loginPassword" placeholder="密码" icon="key"></b-input>
        </b-field>
        <button :disabled="!loginUid || !loginPassword" class="button is-primary is-medium" type="submit">登入</button>
      </form>
    </div>
  </div>
</template>

<script>
import cache from '@/core/cache'
import auth from '@/core/auth'
import type from '@/core/type'
import config from '@/core/config'

export default {
  created () {
    // 是否在微信浏览器中打开
    this.openInWechat = auth.openInWechat()
    this.updateAdminMJPFromCache()

    let succ = this.loginByWechat()
    if (succ) {
      return
    }

    succ = this.loginByCachedUser()
    if (succ) {
      return
    }
    // 从缓存登录不成功，执行一次登出还原状态
    this.hub.logout()
    this.loginStatus = 1
    this.showWechatLogin()
  },
  data () {
    return {
      openInWechat: null,
      adminMJPServers: config.ADMIN_MJP_SERVERS,
      // 当前选择的 mjpadm 索引。0 代表正式服，1 代表测试服，2 代表本地服
      selectedAdminMJPIndex: 0,
      selectedAdminMJPServer: null,
      // 微信登录
      wechatAppLogin: null,
      // 企业微信登录
      workWechatAppLogin: null,
      loginStatus: 0,
      loginUid: '',
      loginPassword: '',
      chromeTips: ''
    }
  },
  computed: {
    isDev () {
      return process.env.NODE_ENV === 'development'
    },
    isLogining () {
      return this.loginStatus === 2
    }
  },
  methods: {
    /**
     * 检测 Wechat 登录信息并进行登录
     */
    loginByWechat () {
      const wxloginObj = cache.getValue('wechatLogin', false, true)
      const isProd = this.selectedAdminMJPServer && this.selectedAdminMJPServer.isProd
      if (wxloginObj) {
        // 包含四种登录信息：
        // 普通微信扫码、企业微信扫码、普通微信跳转、企业微信跳转
        console.log('LoginByWechat login with wxloginObj:', wxloginObj)
        // 清空缓存中的微信登录信息
        cache.removeValue('wechatLogin')
        return this.autoLogin(wxloginObj)
      } else if (this.openInWechat === 'wechat') {
        // 在微信浏览器中，直接跳转
        window.location.href = auth.getAuthURI({ isProd, isWork: false })
        return true
      } else if (this.openInWechat === 'wechatwork') {
        // 在企业微信浏览器中，直接跳转，不继续处理
        window.location.href = auth.getAuthURI({ isProd, isWork: true })
        return true
      }
      return false
    },
    /**
     * 检测本地是否有缓存的 user 信息
     * 并进行登录
     */
    loginByCachedUser () {
      // 检测本地 token 是否过期
      const user = cache.getUser()
      if (user) {
        if (cache.isExpire(user.expire)) {
          this.hub.logout()
          return false
        }
        console.log('Login by cached user:', user)
        return this.autoLogin(user)
      }
      return false
    },
    updateAdminMJPFromCache () {
      this.selectedAdminMJPIndex = cache.getAdminMJPIndex()
      this.selectedAdminMJPServer = this.adminMJPServers[this.selectedAdminMJPIndex]
      // AppHeader 需要这个事件
      this.hub.$emit('mjpadm-change', this.selectedAdminMJPServer)
    },
    onAdminMJPSelect (adminMJPIndex) {
      // 更新缓存中保存的 mjpadm 选择索引
      cache.setAdminMJPIndex(adminMJPIndex)
      this.updateAdminMJPFromCache()
      this.showWechatLogin()
    },
    showWechatLogin () {
      console.log('showWechatLogin openInWechat', this.openInWechat)
      if (this.openInWechat) {
        console.warn('OPEN IN Wechat')
        return
      }
      if (this.isLogining) {
        console.warn('NO WechatLogin in logging')
        return false
      }
      // 不同的 API 使用不同的地址
      if (this.selectedAdminMJPServer) {
        if (this.selectedAdminMJPServer.isLocal) {
          this.wechatAppLogin = null
          this.workWechatAppLogin = null
        } else {
          this.wechatAppLogin = auth.getAuthURI({ isProd: this.selectedAdminMJPServer.isProd, isQR: true })
          this.workWechatAppLogin = auth.getAuthURI({ isProd: this.selectedAdminMJPServer.isProd, isWork: true, isQR: true })
        }
      } else {
        this.wechatAppLogin = null
        this.workWechatAppLogin = null
      }
      console.log(`workWechatAppLogin ${this.workWechatAppLogin}`)
      console.log(`wechatAppLogin ${this.wechatAppLogin}`)
    },
    login (user) {
      if (!user.accesstoken) {
        this.hub.alert('登录失败！')
        return false
      }
      this.saveUser(user)
      console.log('login user: %o', user)
      this.hub.$emit('login-success')
      this.$router.replace('/home')
      return true
    },
    saveUser (user) {
      user.typename = type.getTypeName(user.usertype)
      cache.setUser(user)
    },
    async autoLogin (loginObj) {
      const { uid, accesstoken, expire } = loginObj
      console.log(`autoLogin uid:${uid} accesstoken:${accesstoken}`)
      this.loginStatus = 2
      // 根据 accesstoken 和 userid 获取 user 的详细信息，直接传递 mjst 而不是使用 head
      try {
        await type.preload(accesstoken)
        const data = await this.mjp.get('/admin/get/', { idtype: 'adminuid', idvalue: uid, mjst: accesstoken })
        data.user.accesstoken = accesstoken
        data.user.expire = expire
        return this.login(data.user)
      } catch (error) {
        this.loginStatus = 1
      }
      return false
    },
    async onSubmit () {
      this.loginStatus = 2
      const loginObj = { username: this.loginUid, password: this.loginPassword }

      try {
        const userObj = await this.mjp.post('/admin/login/username/', loginObj)
        delete userObj.error
        delete userObj.code
        delete userObj.message
        await type.preload(userObj.accesstoken)
        this.login(userObj)
      } catch (error) {
        this.loginStatus = 1
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>

form {
  width: 260px;
}

#mjpSelector {
  width: 260px;
}

#loginRoot {
  text-align: center;
}

#loginRoot > div {
  padding-bottom: 20px;
}
</style>
